const makeUrlTo = {
  creator: c => `/group/${c.groupId}/${c.creatorId}/${c.provider}/`,
  topic: t => `/topic/${t.topicId}`,
  subtopic: s => `/subtopic/${s.subtopicId}`,
}
export default makeUrlTo
